import { StrHlp } from './string.helper';

/**
 * generate32bit hash code from given values
 */
export class HashCodeBuilder {
  private _value = 3619645487;

  /**
   * Create hashcode for given values
   * @param {number | string | undefined | null} args values to add initially
   */
  public constructor(...args: (number | string | undefined | null)[]) {
    if (args.length) this.add(...args);
  }

  /**
   * @return { number } current hash value
   */
  public valueOf(): number {
    return this._value;
  }

  /**
   * combine current value with series of new values
   * @param {number | string | undefined | null} args
   */
  public add(...args: (number | string | undefined | null)[]): void {
    args.forEach((x) => {
      if (!x) x = 0;

      if (StrHlp.isString(x)) {
        this.addString(x as string);
      } else {
        this.addNumber(x as number);
      }
    });
  }

  /**
   * combine current value with new numeric value
   * @param {number} x
   */
  public addNumber(x: number): void {
    this._value = (Math.imul(this._value, 2234965087) + x) | 0;
  }

  /**
   * combine current value with new numeric value
   * @param {number} x
   */
  public addString(x: string): void {
    for (let i = 0; i < x.length; i++) {
      this.addNumber(x.charCodeAt(i));
    }
  }
}
